import { AnnotationStatus } from "@faro-lotv/ielement-types";
import { PALETTE_VARS } from "@styles/palette-vars";

/**
 * Color of each status, from the palette slots the flat-ui ChipStatus uses, so the summary
 * matches the status chips and follows the color scheme. The two neutral statuses share the
 * default chip there, so they take the secondary and disabled text colors to stay apart.
 */
const MARKUP_STATUS_COLORS = {
  [AnnotationStatus.Unclassified]: PALETTE_VARS.text.disabled,
  [AnnotationStatus.Open]: PALETTE_VARS.text.secondary,
  [AnnotationStatus.InProgress]: PALETTE_VARS.primary.main,
  [AnnotationStatus.ToReview]: PALETTE_VARS.tertiary.main,
  [AnnotationStatus.Resolved]: PALETTE_VARS.success.main
};

/** Returns the color of the status in the summary */
export function getMarkupStatusChipColor(status) {
  return MARKUP_STATUS_COLORS[status];
}